import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal } from "./Motion";

export const Faq = ({ items = [], title = "Questions fréquentes", eyebrow = "FAQ" }) => {
  if (!items.length) return null;
  return (
    <section className="py-24 md:py-32" data-testid="faq-section">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 grid lg:grid-cols-[0.8fr_1.2fr] gap-12">
        <Reveal>
          <p className="eyebrow text-sage">{eyebrow}</p>
          <h2 className="h2 mt-5 text-forest">{title}</h2>
          <p className="lead-text mt-6 text-ink/70 max-w-md">Les réponses aux questions que l'on nous pose le plus souvent avant un traitement anti-moustique en Gironde.</p>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="border-t border-moss/15">
            {items.map((f, i) => (
              <AccordionItem key={f.q} value={`f${i}`} className="border-b border-moss/15">
                <AccordionTrigger className="py-6 text-left font-display text-lg md:text-xl font-bold text-forest hover:no-underline" data-testid={`faq-trigger-${i}`}>{f.q}</AccordionTrigger>
                <AccordionContent className="pb-6 text-[15px] md:text-base leading-relaxed text-ink/75">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
